import React from "react";

const TrustStrip = () => {
  const stats = [
    { number: "10,000+", label: "Repairs Completed", icon: "fas fa-tools" },
    { number: "19+", label: "Years Experience", icon: "fas fa-award" },
    { number: "4.6★", label: "Google Rated (163+ Reviews)", icon: "fab fa-google" },
    { number: "Same Day", label: "Service Available", icon: "fas fa-bolt" },
  ];

  return (
    <section
      style={{
        background: "linear-gradient(135deg, #18305d 0%, #0f1d3a 100%)",
        padding: "28px 0",
        borderBottom: "3px solid #ffaa19",
      }}
      aria-label="Cell Station trust indicators"
    >
      <div className="container">
        <div className="row justify-content-center">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="col-6 col-md-3 text-center"
              style={{ padding: "10px", color: "#ffffff" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <i
                  className={stat.icon}
                  style={{ fontSize: "1.4rem", color: "#ffaa19" }}
                  aria-hidden="true"
                />
                <div style={{ textAlign: "left" }}>
                  <div
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: 800,
                      lineHeight: 1,
                      color: "#ffffff",
                    }}
                  >
                    {stat.number}
                  </div>
                  <div
                    style={{
                      fontSize: "0.78rem",
                      color: "rgba(255,255,255,0.8)",
                      marginTop: "4px",
                    }}
                  >
                    {stat.label}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
